<template>
  <div class="comment-wrap user">
    <!-- USER AVATAR -->
    <figure class="user-avatar medium">
      <img :src="'/images/avatars/' + comment.user.avatar" alt="" />
    </figure>
    <!-- /USER AVATAR -->
    <div class="comment">
      <p
        @click.prevent="showCommentDeleteModal()"
        v-if="comment.read_at != null"
        :title="'Read: ' + readAt"
        class="report tooltip"
      >
        {{ comment.created_at | fromNowAgo }}
      </p>
      <p @click.prevent="showCommentDeleteModal()" v-else class="report">
        {{ comment.created_at | fromNowAgo }}
      </p>

      <p class="text-header">{{ comment.user.name }}</p>
      <!-- PIN -->
      <span class="pin greyed"
        >Requested revision ({{ comment.commentable.deadline }} hours)</span
      >
      <!-- /PIN -->

      <i v-if="isDeclined(comment)" class="fa fa-times-circle negative"></i>

      <i v-if="isAccepted(comment)" class="fa fa-check-circle-o positive"></i>
      <br />

      <div class="quote revision">
        <p class="text-header small">Revision comments:</p>
        <p class="message">{{ comment.body }}</p>

        <p v-if="comment.files.length > 0" class="text-header">
          Attached files:
        </p>
        <div
          v-if="comment.files.length > 0"
          v-for="file in comment.files"
          class="file-name"
        >
          <a :href="'/files/' + order.hashId + '/' + file.name">
            <i class="fa fa-arrow-circle-o-down" aria-hidden="true"></i>
          </a>
          <a :href="'/files/' + order.hashId + '/' + file.name">{{
            file.name
          }}</a>
        </div>
      </div>

      <div
        v-if="
          isPending(comment) &&
            $user.isWriter() &&
            !$user.isEditor() &&
            order.status_name === 'Revision'
        "
      >
        <form method="POST" action="/">
          <button
            @click.prevent="acceptRevision()"
            type="submit"
            class="link primary"
          >
            <i class="fa fa-check-circle-o"></i> Accept revision
          </button>
        </form>

        <a
          href="#decline-revision-popup"
          @click.prevent="showRevisionDeclineModal()"
          class=""
          ><p><i class="fa fa-times-circle"></i> Decline revision</p></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["comment", "order"],
  data() {
    return {};
  },

  created() {},

  computed: {
    readAt: function() {
      return this.$options.filters.fromNowAgo(this.comment.read_at);
    },
  },

  methods: {
    isPending(comment) {
      return comment.commentable.status === 0;
    },
    isAccepted(comment) {
      return comment.commentable.status === 1;
    },
    isDeclined(comment) {
      return comment.commentable.status === 2;
    },

    acceptRevision() {
      this.loading = true;

      axios
        .post("/api/orders/actions/revision-accept", {
          order_id: this.order.hashId,
        })
        .catch((error) => {
          console.log(error);
          flash("Given data was invalid", "error");
          this.loading = false;
        })
        .then(({ data }) => {
          flash(data.flash);
          this.$eventBus.$emit("refreshOrder");
          this.$eventBus.$emit("refreshComments");
          this.loading = false;
        });
    },

    showRevisionDeclineModal() {
      this.$modal.show("revisionDeclineModal", { order: this.order });
    },

    showCommentDeleteModal() {
      if (this.$user.can("commentDelete", "commentPolicy")) {
        this.$modal.show("commentDeleteModal", { comment: this.comment });
      }
    },
  },
};
</script>
